<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Tarif</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama Paket</label>
                                                <input type="text" class="form-control" placeholder="Nama Area..." v-model="nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Tarif Paket (Pastikan Tarif paket tidak pakai titik/koma. Mis : 50000)</label>
                                                <input type="number" class="form-control" placeholder="Tarif Paket..." v-model="tarif" min="0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="Simpan">Simpan</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			nama: '', 
			tarif: '',
		}
	},
	methods: {
        Simpan() {
			if (this.nama == "") {
				alert("Nama tidak boleh kosong");
				return false;
			}
			if (this.tarif == "") {
				alert("Tarif tidak boleh kosong");
				return false;
			}

			var data = new FormData();
            data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            data.append('nama', this.nama);
            data.append('tarif', this.tarif.replace(/[^0-9]/g, ''));
			
            var apiUrl = 'TambahTarif';
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
                    location.href="#/setting/paket"
				} else {
				    alert(x.pesan);
				}
			})
        }
	},
	mounted() {

	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/setting/paket-tambah.vue